import { useIntl } from '@edx/frontend-platform/i18n';

import { Head } from '@src/generic';
import { baseAppUrl } from '@src/utils';
import HomeBannerSlot from '../plugin-slots/HomeBannerSlot';
import HomeCoursesListSlot from '../plugin-slots/HomeCoursesListSlot';
import messages from './messages';

export const LANDING_PLACEHOLDERS = {
  trustedBy: ['10000 CODEURS', 'RISCE', 'SOCIAL IMPACTS'],
  stats: [
    { number: '100K+', label: 'Active learners' },
    { number: '94%', label: 'Satisfaction rate' },
    { number: '500+', label: 'Courses available' },
    { number: '50+', label: 'Certificates' },
  ],
  testimonials: [
    {
      quote: 'The rigor and quality of WutiSkill courses transformed my career by structuring my strategic vision.',
      author: 'Fatou Diop',
      role: 'Senior Product Manager',
    },
    {
      quote: 'A precise learning experience. Every module gets to the point while keeping a high standard.',
      author: 'Mamadou Sy',
      role: 'Tech Lead',
    },
    {
      quote: 'The format is ideal for professionals. The interface stays sober, clear, and genuinely effective.',
      author: 'Awa Ndiaye',
      role: 'Data Analyst',
    },
  ],
};

const HomePage = () => {
  const intl = useIntl();

  return (
    <>
      <Head />
      <div className="catalog-landing-page">
        <HomeBannerSlot />

        <HomeCoursesListSlot />

        <section className="catalog-home-cta">
          <div className="catalog-home-cta__container">
            <h2 className="catalog-home-cta__title">{intl.formatMessage(messages.ctaTitle)}</h2>
            <p className="catalog-home-cta__description">
              {intl.formatMessage(messages.ctaDescription)}
            </p>
            <a className="catalog-ui-button catalog-ui-button--primary catalog-ui-button--hero" href={baseAppUrl('/register')}>
              {intl.formatMessage(messages.ctaButton)}
            </a>
          </div>
        </section>
      </div>
    </>
  );
};

export default HomePage;
